export const websiteRegex = /^(https?:\/\/)?([\w.-]+)\.([\w]{2,})(\/[\w-./?=%&]+)?$/;
export const normalizeStringRegex = /<[^>]+>/g;

export const regex = {
  email: /^[A-Za-z0-9_!#$%&'*+\\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/gm,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-]).{8,}$/,
};

export const socialLink = {
  facebookRegex: /(http|https)\:\/\/(?:www\.)?facebook.com\/.*/i,
  twitterRegex: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/(\w+)/,
  instagramRegex: /http(?:s)?:\/\/(?:www\.)?instagram\.com\/(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}.*$/i,
  linkdinRegex: /(http|https)\:\/\/(?:www\.)?(?:in\.)?linkedin\.com\/(?:company\/[^\/]+\/?|in\/[^\/]+)\/?/,
  pintrestRegex: /(http|https)\:\/\/(?:www\.)?(?:in\.)?pinterest\.com\/?(?:in\.)?\/.*$/,
  websiteRegex: /^((https?|ftp|smtp):\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]+(\/[a-zA-Z0-9#_.\-]+\/?)*$/,
};
